// extracted by mini-css-extract-plugin
export default {"main":"adviceone_main__xuZkm","item":"adviceone_item__L4z9A","image":"adviceone_image__ihu+X","typeClining":"adviceone_typeClining__vqLWs","textp":"adviceone_textp__a7crC"};